var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", disabled: _vm.disableControls },
              on: { click: _vm.previous },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-rewind")])],
            1
          ),
          !_vm.update
            ? _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "", disabled: _vm.disableControls },
                  on: { click: _vm.play },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-play")])],
                1
              )
            : _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "", disabled: _vm.disableControls },
                  on: { click: _vm.pause },
                },
                [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-pause")])],
                1
              ),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", disabled: _vm.disableControls },
              on: { click: _vm.next },
            },
            [
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v("mdi-fast-forward"),
              ]),
            ],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", disabled: _vm.disableControls },
              on: { click: _vm.stop },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-stop")])],
            1
          ),
        ],
        1
      ),
      _c("Plotly", { attrs: { data: _vm.chartData, layout: _vm.chartLayout } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }